import {
  AuthFormBoxRowGaps,
  AuthFormBoxTemplate,
  TextBlock,
  TextBlockDirection,
  TextBlockRowGap,
  TextBoxMaxLine1Headline2,
} from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { AuthTabs } from '~/features/change-auth-type'
import { model as forgotPasswordFeature } from '~/features/subscriber/forgot-password'
import {
  SignInByEmailForm,
  SignInByPhoneForm,
  SignInErrorMessage,
  model as signInFeatureModel,
} from '~/features/subscriber/sign-in'
import { model as signUpFeatureModel } from '~/features/subscriber/sign-up'
import { SignUpLink } from './SignUpLink'
import { $signInFormTranslations } from './i18n'
import { $isSignInByEmailActivated, $isSignInByPhoneActivated } from './model'

export const SignInForm = (): JSX.Element => {
  const formTranslations = useUnit($signInFormTranslations)
  const signUpEnabled = useUnit(signUpFeatureModel.$enabled)
  const signUpExternalDomain = useUnit(signUpFeatureModel.$link)
  const forgotPasswordEnabled = useUnit(
    forgotPasswordFeature.$resetPasswordEnabled
  )
  const sighUpRedirectLink = signUpExternalDomain || '/sign-up'

  const isPhoneRegistration = useUnit($isSignInByPhoneActivated)
  const isEmailRegistration = useUnit($isSignInByEmailActivated)

  const signInWithPhoneEnabled = useUnit(
    signInFeatureModel.$signInWithPhoneEnabled
  )

  const rowGap = signInWithPhoneEnabled
    ? AuthFormBoxRowGaps.SIZE_160
    : AuthFormBoxRowGaps.SIZE_150

  return (
    <AuthFormBoxTemplate rowGap={rowGap}>
      <TextBoxMaxLine1Headline2 title={formTranslations.title} />
      {signInWithPhoneEnabled && <AuthTabs />}
      {isPhoneRegistration && <SignInByPhoneForm />}
      {isEmailRegistration && (
        <SignInByEmailForm
          forgotPasswordEnabled={forgotPasswordEnabled}
          rowGap={AuthFormBoxRowGaps.SIZE_170}
        />
      )}

      <TextBlock
        direction={TextBlockDirection.ROW}
        rowGap={TextBlockRowGap.INDENT_20}
      >
        {signUpEnabled && (
          <SignUpLink sighUpRedirectLink={sighUpRedirectLink} />
        )}
      </TextBlock>
      <SignInErrorMessage />
    </AuthFormBoxTemplate>
  )
}
